module.exports = __webpack_public_path__ + "media/common/img/disabled_chart-ecb8c107e1f0de7e66e9df99d8fb566b.png";